import { render, staticRenderFns } from "./IDQuery.vue?vue&type=template&id=014ce7a4&scoped=true&"
import script from "./IDQuery.vue?vue&type=script&lang=js&"
export * from "./IDQuery.vue?vue&type=script&lang=js&"
import style0 from "./IDQuery.vue?vue&type=style&index=0&id=014ce7a4&prod&scoped=true&lang=css&"
import style1 from "./IDQuery.vue?vue&type=style&index=1&id=014ce7a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ce7a4",
  null
  
)

export default component.exports